<mat-toolbar class="mat-accent m-0" style="height: 50px">
  <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <span
      class="title dialog-title">{{user?.fullName || 'User Details'}}&nbsp;&nbsp;<small>(since&nbsp;:&nbsp;{{user.created_date | date }})</small></span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
      <mat-icon style="color: white">close</mat-icon>
    </button>
  </div>
</mat-toolbar>
<div>
  <nav mat-tab-nav-bar>
    <a mat-tab-link (click)="selectedTab = 'userDetails'" [active]="selectedTab == 'userDetails'"
      style="padding: 0px;">Details </a>
    <a mat-tab-link (click)="selectedTab = 'activities'" [active]="selectedTab == 'activities'"
      style="padding: 0px;">Activities </a>
    <a mat-tab-link (click)="selectedTab = 'alerts'" [active]="selectedTab == 'alerts'" style="padding: 0px;">Alerts
    </a>
  </nav>
  <div class="mdl-grid p-12 tab-content dialog-content" [class.show]="selectedTab == 'userDetails'">
    <div class="mdl-cell mdl-cell--7-col userData" style="float:left">
      <div class="mdl-grid">
        <div class="mdl-cell mdl-cell--3-col">
          <img mat-card-image src="assets/images/avatars/profile.jpg" alt="Ward Profile"
            style="border-radius:5% ; width :100% ">
        </div>
        <div class="mdl-cell mdl-cell--9-col">
          <div>
            <b>Name :</b> {{user?.first_name}} {{user?.last_name || ''}}<br />
            <b>Role :</b> {{user?.role || '---'}}<br />
            <b>Email : </b> {{user?.email || '---'}}<br />
            <b>Address :</b>
            {{user?.address || '---'}}&nbsp;{{ user?.city}}&nbsp;{{user?.state}}&nbsp;{{user?.zip}}<br />
            <b>Contact no :</b> {{user?.phone || '---'}}<br />
            <b>Organization :</b> {{getOrgDetails(user.organization_id) || '---'}}<br />
          </div>
        </div>
      </div>
      <div>
        <h6>Associated Cases</h6>
        <hr>
        <div *ngIf="caseDetails">
          <mat-table [dataSource]="caseDetails">
            <ng-container matColumnDef="caseNo">
              <mat-cell *matCellDef="let element">
                {{element?.summary?.case_number || '---'}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-cell *matCellDef="let element"> {{element?.ward?.name}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="created_date">
              <mat-cell *matCellDef="let element"> {{element?.summary?.created_date | date}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="view">
              <mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="viewCaseDetails(element)">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          <mat-paginator #paginator [pageSize]="3">
          </mat-paginator>
        </div>
        <ng-template *ngIf="!caseDetails">
          <div style="text-align: center;margin: 50px;font-size: 25px; ">
            No Case is associated with this user
          </div>
        </ng-template>


      </div>

    </div>
    <div class="mdl-cell mdl-cell--5-col caseData" style="float:right" *ngIf="selectedCase">
      <div class="caseDetails" *ngIf="selectedCase">
        <div class="caseHead">
          <span>{{selectedCase?.summary?.case_number}}</span>
          <button style="float: right" mat-button class="mat-icon-button" (click)="selectedCase = null"
            aria-label="Close dialog">
          </button>
        </div>
        <br>
        <div class="casecontent">
          <!-- <hr> -->
          <h4>{{selectedCase?.ward?.name || 'Case Details'}}</h4>
          <div class="details">
            <b>Address :</b>
            {{selectedCase?.ward?.address || '---'}}&nbsp;{{ selectedCase?.ward?.city}}&nbsp;{{selectedCase?.ward?.state}}&nbsp;{{selectedCase?.ward?.zip}}<br />
            <b>DOB :</b> {{selectedCase?.ward?.date_of_birth | date}}<br />
            <b>Language :</b> {{selectedCase?.ward?.language}}
          </div>
          <h6>People Involved</h6>
          <mat-chip-list *ngIf="selectedCaseContacts">
            <mat-chip class="userChips" *ngFor="let people of selectedCaseContacts" [matTooltip]="people.role"
              matTooltipPosition="above">
              {{people?.first_name}}{{people?.last_name}}</mat-chip>
          </mat-chip-list>
          <div *ngIf="selectedCase.guardian != null">
            <h6>Guardian Detail</h6>
            <div class="details">
              <b>Income:</b> ${{selectedCase?.guardian.income}}<br>
              <b>Language: </b> {{selectedCase?.guardian.language}}<br>
              <b>Married:</b> {{selectedCase.guardian.married ? 'Yes' : 'No'}}<br>
              <b>Relationship With Lawyer: </b> {{selectedCase?.guardian.relationshipWithLawyer}}
            </div>
          </div>
        </div>
        <a class="openCase" (click)="openCase(selectedCase.id)">view more Details..</a>
      </div>
    </div>
    <div *ngIf="!selectedCase">
      <div style="text-align: center;margin: 50px 100px;font-size: 25px; ">
        No Case is associated with this user
      </div>
    </div>
  </div>
  <div class="p-12 tab-content activities" [class.show]="selectedTab == 'activities'">
    <recentActivity></recentActivity>
  </div>
  <div class="p-12 tab-content activities" [class.show]="selectedTab == 'alerts'">
    <alertList [userId]="user.id" [alertStatus]="true"></alertList>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/user-details-dialog/user-details-dialog.component.html